import { negate } from 'lodash';

import isEmptyString from './isEmptyString';

/**
 * Provided a string, will return the string split on spaces, commas,
 * semicolons, tabs, or new lines
 */
const parseSeparatedList = (list: string): Array<string> =>
  list.split(/[\s,;\t\n]+/).filter(negate(isEmptyString));

export default parseSeparatedList;
